import { CURRENT_INSTANCE } from '@lib/utils';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

interface MarkdownRendererProps {
  content: string;
  onCodeClick?: () => void;
}
const CustomLink = ({
  href,
  children,
}: {
  href?: string | undefined;
  children?: React.ReactNode;
}) => {
  if (!href) return <>{children}</>;
  if (href.startsWith('/')) {
    const path = CURRENT_INSTANCE.isDefault ? '' : `/instance/${CURRENT_INSTANCE.name}`;
    return (
      <Link to={`${path}${href}`} target="_blank">
        {children}
      </Link>
    );
  }
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
};

const MarkdownRenderer = (props: MarkdownRendererProps) => {
  return (
    <div className="markdown-renderer whitespace-normal">
      <ReactMarkdown
        components={{
          a: ({ node, ...linkProps }) => <CustomLink {...linkProps} />,
          h1: ({ children }: { children?: React.ReactNode }) => (
            <h1 className="font-bold mb-1">{children}</h1>
          ),
          p: ({ children }: { children?: React.ReactNode }) => <p className="my-2">{children}</p>,
          ol: ({ children }: { children?: React.ReactNode }) => (
            <ol className="block list-decimal m-0 p-0 my-2 pl-5">{children}</ol>
          ),
          ul: ({ children }: { children?: React.ReactNode }) => (
            <ul className="block list-disc m-0 p-0 my-2 pl-5">{children}</ul>
          ),
          code: ({ children }: { children?: React.ReactNode }) => (
            <span className="underline inline cursor-pointer text-base" onClick={props.onCodeClick}>
              {children}
            </span>
          ),
        }}
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
      >
        {props.content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
